module.exports = __webpack_public_path__ + "img/normal-buy.1689e95b.png";